import React, { useState } from 'react';
import MovieCard from './MovieCard';

const SearchMovies = () => {
    const [query, setQuery] = useState('');

    const [movies, setMovies] = useState([]);

    const searchMovies = async (e) => {
        e.preventDefault();
        console.log('Hey Hello There!');

        // const query = "Jurassic Park";


        const url = `https://api.themoviedb.org/3/search/movie?api_key=a1ca6ba0ca4909aaa160b9210fa69b1a&language=en-US&query=${query}&page=1&include_adult=false`;

        try {
            const res = await fetch(url); 
            const data = await res.json();
            console.log(data.results);
            setMovies(data.results);
        }catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <form className="form"  onSubmit={searchMovies}>
                <label htmlFor="query" className="label">Movie Name</label>
                <input autoComplete="off" type="text" name="query" className="input" placeholder="Jurrassic Park" value={query} onChange={(e) => setQuery(e.target.value)} />
                <button type="submit" className="button">Search</button>
            </form>
            <div className="card-list">
                {movies.filter(movie => movie.poster_path).map(movie => (
                    <MovieCard movie={movie}  key={movie.id}/>
                ) )}
            </div>
        </>
    )
}

export default SearchMovies
